import request from '@/utils/request'

export function getNewsArticle(data) {
  return request({
    url: '/ItaWebSite/getNewsArticle',
    method: 'post',
    data,
  })
}

export function deleteNewsArticle(data) {
  return request({
    url: '/ItaWebSite/deleteNewsArticle',
    method: 'post',
    data,
  })
}

export function saveNewsArticle(data) {
  return request({
    url: '/ItaWebSite/saveNewsArticle',
    method: 'post',
    data,
  })
}

export function getManufacturersList(data) {
  return request({
    url: '/ItaWebSite/getManufacturersList',
    method: 'post',
    data,
  })
}

export function deleteManufacturer(data) {
  return request({
    url: '/ItaWebSite/deleteManufacturer',
    method: 'post',
    data,
  })
}

export function saveManufacturer(data) {
  return request({
    url: '/ItaWebSite/saveManufacturer',
    method: 'post',
    data,
  })
}
